import { render, staticRenderFns } from "./CategoriaEmpleado.vue?vue&type=template&id=0c61907f&scoped=true"
import script from "./CategoriaEmpleado.vue?vue&type=script&lang=js"
export * from "./CategoriaEmpleado.vue?vue&type=script&lang=js"
import style0 from "./CategoriaEmpleado.vue?vue&type=style&index=0&id=0c61907f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c61907f",
  null
  
)

export default component.exports